import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isNumeric, isEmpty, createCustomPropType } from '../../../js/app/react/validators';
import Modal from '../../CommonComponents/AdvModal';
import ReactHighcharts from '../../CommonComponents/Highcharts';

class DetailedAssetAllocationView extends Component {
  constructor() {
    super();
    this.state = {
      highchart: null,
    };
    this.onHighcharts = this.onHighcharts.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
  }

  onHighcharts(highchart) {
    this.setState({
      highchart,
    });
  }

  onMouseOver(index) {
    return () => {
      const { highchart } = this.state;
      if (!isEmpty(highchart)) {
        highchart.series[0].data[index].setState('hover');
      }
    };
  }

  onMouseOut(index) {
    return () => {
      const { highchart } = this.state;
      if (!isEmpty(highchart)) {
        highchart.series[0].data[index].setState('');
      }
    };
  }

  render() {
    const {
      detailedAssetAllocationOpen,
      onDismiss,
      clientId,
      chartData,
      legend,
      name,
    } = this.props;
    const { ADV } = window;
    return (
      <Modal
        className="popup what-ifs-detailed-asset-allocation-popup"
        isOpen={detailedAssetAllocationOpen}
        onRequestClose={onDismiss(clientId)}
        overlayClassName="closerdiv"
        shouldCloseOnOverlayClick={false}
      >
        <div className="what-ifs-detailed-asset-allocation-popup-header">
          <div className="what-ifs-detailed-asset-allocation-popup-header-title">
            Monte Carlo Simulation Asset Allocation
          </div>
          <span className="what-ifs-detailed-asset-allocation-popup-header-close">
            <i
              className="fa fa-times what-ifs-detailed-asset-allocation-popup-header-close-button"
              onClick={onDismiss(clientId)}
              role="button"
              tabIndex={0}
              onKeyDown={() => {}}
            />
          </span>
        </div>
        <div className="what-ifs-daa-layout-chart-name">{name}</div>
        <div className="what-ifs-daa-layout-chart-legend">
          <div className="what-ifs-daa-layout-chart">
            <ReactHighcharts
              onHighchartsRef={this.onHighcharts}
              autoResize
              container="DetailedAssetsAllocation"
              options={chartData}
            />
          </div>
          <div className="what-ifs-daa-layout-legend">
            <ul className="what-ifs-daa-legend-ul adv-scrollbars">
              {legend.map((item, index) => (
                <li
                  key={`${item.value}-${item.label}-${item.colour}`}
                  className={`what-ifs-daa-legend-li${!item.value ? ' inactive' : ''}`}
                  data-daa-id={item.label}
                  onMouseEnter={this.onMouseOver(index)}
                  onMouseLeave={this.onMouseOut(index)}
                >
                  <i
                    className="what-ifs-daa-legend-color"
                    style={{ backgroundColor: item.color }}
                  />
                  <span className="what-ifs-daa-legend-label">{item.label}</span>
                  <span className="what-ifs-daa-legend-percent">
                    {ADV.util.number_format(item.value * 100, 1)}%
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Modal>
    );
  }
}
DetailedAssetAllocationView.defaultProps = {};

DetailedAssetAllocationView.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
  detailedAssetAllocationOpen: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  chartData: PropTypes.shape({}).isRequired,
  legend: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  name: PropTypes.string.isRequired,
};

export default DetailedAssetAllocationView;
